










































import {Vue, Component} from 'vue-property-decorator';
import {toI18n} from '@/utils/commonUtils';

@Component
export default class ModifyFrontDisplay extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }
  private frontDisplayYn: string = 'NONE';
  private get mallProductNos() {
    return this.$route.params.mallProductNos.split(',');
  }

  private save() {
    if (this.frontDisplayYn === 'NONE') {
      alert(this.toI18n('PLEASE_ENTER_A_VALUE'));
      return;
    }

    const mallProductNos = this.mallProductNos;
    const frontDisplayYn = this.frontDisplayYn;
    this.$api
      .putProductsFrontdisplay({
        data: {
          frontDisplayYn,
          productNos: mallProductNos
        }
      })
      .then(({data}: any): void => {
        // if (data.failures && data.failures.length) {
        //   return alert(data.failures[0].message);
        // }
        window.opener.postMessage({modifyFrontDisplay: true, data});
        this.close();
      });
  }

  private close() {
    window.close();
  }

  private created() {
    document.body.classList.add('popup', 'popup_medium');
    window.name = 'frontDisplay';
  }
}
